import { Expose } from "class-transformer";

export class AIProvider {
  @Expose()
  id!: string;

  @Expose()
  code!: string;

  @Expose()
  label!: string;

  @Expose()
  kind!: string;

  @Expose()
  isEnabled!: boolean;

  @Expose()
  requiredMeta?: Record<string, string>;
}

export class AIModel {
  @Expose()
  id!: string;

  @Expose()
  providerId!: string;

  @Expose()
  provider?: AIProvider;

  @Expose()
  slug!: string;

  @Expose()
  label!: string;

  @Expose()
  isEnabled!: boolean;

  @Expose()
  isDefault!: boolean;

  @Expose()
  isHelpMeCreateDefault!: boolean;

  @Expose()
  metadata?: Record<string, string>;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  constructor(partial?: Partial<AIModel>) {
    if (partial) {
      Object.assign(this, partial);
    }
  }
}

export interface CreateAIModelDto {
  providerId: string;
  slug: string;
  label: string;
  isEnabled?: boolean;
  isDefault?: boolean;
  isHelpMeCreateDefault?: boolean;
  metadata?: Record<string, string>;
}

export interface UpdateAIModelDto extends Partial<CreateAIModelDto> {
  id: string;
}
